<script setup lang="ts">
import {
  computed,
} from 'vue';
import {
  useRoute,
  useRouter,
} from 'vue-router';

import VCard from '@components/card/VCard/VCard.vue';
import {
  AFF_BALANCES_LIST_QUERY_KEY,
  AFF_BALANCES_PERMISSIONS,
  AFFILIATE_BALANCE_QUERY_KEY,
  AFFILIATE_BALANCES_LIST_ROUTE_NAME,
  TRANSLATION_GROUP_AFF_BALANCES,
} from '@modules/aff-balances/constants';
import { useAffiliateBalanceQuery } from '@modules/aff-balances/queries';
import PaymentSystemWithdrawalForm from '@modules/payment-systems/components/PaymentSystemWithdrawalForm/PaymentSystemWithdrawalForm.vue';
import { useQueryClient } from '@tanstack/vue-query';
import { isString } from '@utils/guards';

const route = useRoute();
const router = useRouter();
const queryClient = useQueryClient();
const id = computed<number>(() => (
  isString(route.params.id) ? Number(route.params.id) : 0
));

const { data: balance } = useAffiliateBalanceQuery();

function onSubmit(): void {
  void queryClient.invalidateQueries({
    predicate: (query) => isString(query.queryKey[0]) && [
      AFF_BALANCES_LIST_QUERY_KEY,
      AFFILIATE_BALANCE_QUERY_KEY,
    ].includes(query.queryKey[0]),
  });
  router.back({
    name: AFFILIATE_BALANCES_LIST_ROUTE_NAME,
  });
}
</script>

<template>
  <VCard v-data-qa-auto-id="'BalancesWithdrawalPage'"
    type="form"
    :title="$getTranslation(TRANSLATION_GROUP_AFF_BALANCES, 'WITHDRAWAL_HEADER')"
  >
    <PaymentSystemWithdrawalForm
      is-select-button
      :aff-id="id"
      :balance="balance"
      query-type="cashout"
      :permission="AFF_BALANCES_PERMISSIONS.WITHDRAW"
      :back-route="{
        name: AFFILIATE_BALANCES_LIST_ROUTE_NAME,
      }"
      @submit="onSubmit"
    />
  </VCard>
</template>
